import React from 'react';
import { paraQuem, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight, CheckCircle2 } from 'lucide-react';

const ParaQuemSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="py-24 bg-[#24293f] relative overflow-hidden">
      {/* Background decorations - optional, similar to ConflitosSection if desired, or plain */}

      <div className="max-w-7xl mx-auto px-6">



        {/* Center Container */}
        <div className="flex justify-center mb-12">
          {/* Green Card */}
          <div className="w-full max-w-2xl group relative bg-[#1a382e] rounded-2xl overflow-hidden border border-emerald-900/50 hover:border-emerald-500/50 transition-colors duration-300">
            {/* Header */}
            <div className="bg-emerald-900/30 p-8 border-b border-emerald-900/30">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 border-2 border-emerald-500/50 rounded-lg flex items-center justify-center bg-emerald-900/40">
                  <CheckCircle2 className="w-6 h-6 text-emerald-500" />
                </div>
                <h3 className="text-xl font-semibold text-white">
                  Pra quem é?
                </h3>
              </div>
            </div>

            <div className="p-8">
              <ul className="space-y-4">
                {paraQuem.items.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-3 text-emerald-100 group-hover:text-white transition-colors"
                  >
                    <div className="mt-1 w-5 h-5 rounded-full bg-emerald-900/50 border border-emerald-500/30 flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-[#32D74B] hover:bg-[#28b03d] text-white px-5 py-3 text-sm md:px-8 md:py-4 md:text-lg rounded-lg font-bold uppercase tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-green-500/25"
          >
            <MessageCircle className="w-5 h-5" />
            {paraQuem.cta || siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

      </div>
    </section>
  );
};

export default ParaQuemSection;